import { Size } from '~/types/ThemeTypes'
import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  ThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

export enum MangoCloseButtonVariant {
  Primary = 'brand.fg',
  AlertWindow = 'alertWindow',
}
const mangoCloseButtonStyleparts = ['closeButton', 'closeButtonIcon']

const helpers = createMultiStyleConfigHelpers(mangoCloseButtonStyleparts)
export const MangoCloseButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    closeButton: {
      display: 'flex',
      boxSize: '32px',
      marginRight: '-8px',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      cursor: 'pointer',
      userSelect: 'none',
      backgroundColor: 'transparent',
      _hover: {
        backgroundColor: 'bg.muted',
      },
      _active: {
        backgroundColor: 'bg.emphasized',
      },
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brand.solid',
        outlineOffset: '-2px',
      },
    },
    closeButtonIcon: {
      color: 'fg.default',
      boxSize: '16px',
    },
  },
  variants: {
    [MangoCloseButtonVariant.AlertWindow]: {
      closeButton: {
        backgroundColor: 'transparent',
        _hover: {
          backgroundColor: 'bg.muted',
        },
        _active: {
          backgroundColor: 'bg.emphasized',
        },
      },
      closeButtonIcon: {
        color: 'brand.contrast',
      },
    },
  },
  sizes: {},
  defaultProps: {
    size: Size.md,
  },
})

export const useMangoCloseButtonStyles = (props?: ThemingProps) =>
  mergeMultiStyleConfig(MangoCloseButtonStyle, props) as MultiStyleType<
    typeof mangoCloseButtonStyleparts
  >
